export default "__VITE_PUBLIC_ASSET__a047293d__"